module.exports = {"371723001":"文亭街道","371723002":"永昌街道","371723101":"成武县大田集镇","371723102":"成武县天宫庙镇","371723103":"成武县汶上集镇","371723104":"成武县南鲁集镇","371723105":"成武县伯乐集镇","371723106":"成武县苟村集镇","371723107":"成武县白浮图镇","371723108":"成武县孙寺镇","371723109":"成武县九女集镇","371723110":"成武县党集镇","371723111":"成武县张楼镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371723.json
// module id = 1505
// module chunks = 0